import { render, staticRenderFns } from "./ModalDiscar.vue?vue&type=template&id=3f9d1b68&scoped=true"
import script from "./ModalDiscar.vue?vue&type=script&lang=js"
export * from "./ModalDiscar.vue?vue&type=script&lang=js"
import style0 from "./ModalDiscar.vue?vue&type=style&index=0&id=3f9d1b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d1b68",
  null
  
)

export default component.exports